<template>
  <v-container fluid class="px-0 pt-0">
    <v-row>
      <v-col cols="12" class="pt-0">
          <GameFlowChart
            v-if="game != null && gameFlowDataPerPhasesItems.length > 0 && chartData != null"
            id="xTChart"
            :game="game"
            :xTChart="xTChart"
            :gameFlowDataPerPhasesItems="gameFlowDataPerPhasesItems"
            :chartData="chartData"
            :chartId="chartId"
            :language="currentUserLanguage"
            @loaded="onLoaded($event)"
          ></GameFlowChart>
      </v-col>
    </v-row>
    <v-row v-if="!(game != null && gameFlowDataPerPhasesItems.length > 0 && chartData != null)">
      <v-col cols="12" class="pt-0">
        <v-skeleton-loader type="article" class="flex-grow-1 elevation-2"></v-skeleton-loader>
      </v-col>
      <v-col cols="5" class="pt-0 pr-1">
        <v-skeleton-loader type="list-item@8" class="flex-grow-1 elevation-2"></v-skeleton-loader>
      </v-col>
      <v-col cols="7" class="pt-0 pl-1">
        <v-skeleton-loader type="card" class="flex-grow-1 elevation-2"></v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import GameService from "../../services/game/game.service";
import ChartsService from "../../services/charts.service";
import GameFlowChart from '@/views/game/GameFlowChart';
import ZeroLineChart from "@/views/charts/ZeroLineChart";
import MediaModeForm from '../base/MediaModeForm';
import DriblabSocialMedia from '../base/DriblabSocialMedia';
import GameAvatarMedia from './GameAvatarMedia';
import * as chartConfigs from "@/views/charts/config";
import UserService from '../../services/user.service';
import { round } from '../../utils/functions';
import Dictionary from '../../dictionary';

export default {
  name: 'GameFlow',
  components: {
    GameFlowChart,
    ZeroLineChart,
    MediaModeForm,
    GameAvatarMedia,
    DriblabSocialMedia
  },
  props:{
    gameId:{
      type:Number,
      required: true
    },
    chartId:{
      type:Number,
      default: 0
    },
    language: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      game: null,
      chartData: null,
      slicePeriod: [1, 1, 1, 2, 2, 2],
      sliceMinFrom: [0, 16, 31, 45, 61, 76],
      sliceMinTo: [15, 30, 48, 60, 75, 95],
      metricsPerMinsHeader: [
        { text: this.$t("table.gameFlow.team") , tooltip: this.$t("table.gameFlow.team"), width: "18%", align: 'start', value: 'teamId', sortable: true },
        { text: this.$t("table.gameFlow.period"), tooltip: this.$t("table.gameFlow.period"), width: "20%", align: 'center', value: 'period', sortable: true },
        { text: this.$t("table.gameFlow.possession"), tooltip: this.$t("table.gameFlow.possessionTooltip"), width: "15%", align: 'center', value: 'possession', sortable: true },
        { text: this.$t("table.gameFlow.xT"), tooltip: this.$t("table.gameFlow.xTTooltip") , width: "13%", align: 'center', value: 'xT', sortable: true },
        { text: this.$t("table.gameFlow.pft"), tooltip: this.$t("table.gameFlow.pftTooltip") , width: "15%", align: 'center', value: 'passesFinalThird', sortable: true },
        { text: this.$t("table.gameFlow.xG"), tooltip: this.$t("table.gameFlow.xGTooltip"), width: "13%", align: 'center', value: 'xG', sortable: true }
      ],
      gameFlowDataPerPhasesItems: [],
      xTChart: {
        title: '',
        data: {
          labels: [],
          datasets: [{
              homeTeamId: 0,
              //home team name as label
              label: "",
              awayTeamId: 0,
              awayTeamName: "",
              //Home Team Goals
              homeGoals: [],
              //Home Missed Penalty
              homeMissedPenalty: [],
              //Home Team Red Cards
              homeRedCardsMinute: [],
              //Home Team Formation Change
              homeFormationChangeMinute: [],
              //Away Team Goals
              awayGoals: [],
              //Away Missed Penalty
              awayMissedPenalty: [],
              //Away Team Red Cards
              awayRedCardsMinute: [],
              //Away Team Formation Change
              awayFormationChangeMinute: [],
              startDrinksBreakMinute: [],
              endDrinksBreakMinute: [],
              //drinksBreakMinute: [],
              //First minute of the phase
              firstMinuteOfThePhase: 1,
              //Extra time for the first half of the game
              firstHalfExtraTime: 0,
              tooltipItems: [],
              fill: 'origin',
              borderColor: chartConfigs.lineChartOptions.colors.driblabBlue,
              borderWidth: 2,
              pointBackgroundColor:chartConfigs.lineChartOptions.colors.driblabBlue,
              pointHoverBackgroundColor:chartConfigs.lineChartOptions.colors.driblabBlue,
              pointBorderWidth: 2,
              pointHoverRadius: 2,
              pointHitRadius: 4,
              pointHoverBorderWidth: 3,
              pointRadius: 0,
              data: []
            }]
        },
        options: chartConfigs.ZerolineChartOptions
      }
    };
  },
  mounted: function() {
    this.loadData();
  },
  computed: {
    currentUserLanguage() {
      return this.language ? this.language : this.$store.getters["auth/language"];
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    avatarSize(){
      return this.chartSize ?  {
          width: this.chartSize.width,
          height: this.chartSize.height / 3
      } : null
    },
    lastSearchId() {
      return this.$store.state.auth.lastSearch;
    }
  },
  methods: {
    async loadData() {
      await this.loadMatch();
      this.loadChartData();
      this.getAllGameMetricsPerPhases();

    },
    onLoaded(event){
      //Emit when is loaded
      this.$emit("loaded", event);
    },
    async loadMatch() {
      let gameResponse = await GameService.getGame(this.gameId);
      this.game = gameResponse.data;
      //Replace 48' by lastMinutedPlayedFirstHalf
      this.sliceMinTo.splice(2, 1, this.game.lastMinuteFirstHalfPlayed);
      //Replace 95' by lastMinutedPlayed
      this.sliceMinTo.splice(5, 1, this.game.lastMinutePlayed);
      this.xTChart.title = Dictionary[this.currentUserLanguage]["charts"]["xTTitle"];
      this.xTChart.data.datasets[0].homeTeamId = this.game.homeTeamId;
      //Set home team name as label to overwrite labels on config.js
      this.xTChart.data.datasets[0].label = this.game.homeTeamName;
      this.xTChart.data.datasets[0].awayTeamId = this.game.awayTeamId;
      this.xTChart.data.datasets[0].awayTeamName = this.game.awayTeamName;

      this.xTChart.data.datasets[0].firstHalfExtraTime = this.game.lastMinuteFirstHalfPlayed - 45;
      this.xTChart.options.scales['xAxes'][0].scaleLabel = {
        labelString: Dictionary[this.currentUserLanguage]["table"]["roster"]["minutes"],
        display: true
      };
      this.xTChart.options.scales['yAxes'][0].scaleLabel = {
        labelString: "xThreat",
        display: true
      };


    },
    async loadChartData() {
      let homeGoalsAccum = 0;
      let awayGoalsAccum = 0;
      let chartResponse = await ChartsService.getXTGame(this.gameId);
      this.chartData = chartResponse.data;

      // Detect drinks break ranges by chartData index
      const drinksBreakIndexes = new Set();
      let activeDrinksBreakStartIndex = null;


      this.chartData.forEach((min, index) => {
        if (min.startDrinksBreak) {
          activeDrinksBreakStartIndex = index;
        }

        if (min.endDrinksBreak && activeDrinksBreakStartIndex !== null) {
          for (let i = activeDrinksBreakStartIndex + 1; i <= index; i++) {
            drinksBreakIndexes.add(i);
          }

          activeDrinksBreakStartIndex = null;
        }
      });

      if (activeDrinksBreakStartIndex !== null) {
        for (let i = activeDrinksBreakStartIndex; i < this.chartData.length; i++) {
          drinksBreakIndexes.add(i);
        }
      }

      this.xTChart.data.labels = this.chartData.map(min => (min.minute > 45 && min.periodId === 1) ? `45+${min.minute - 45}'` : min.minute + "'");
      //Get xT (Expected Threat)
      //this.xTChart.data.datasets[0].data = this.chartData.map(min => min.xT.toFixed(3));
      this.xTChart.data.datasets[0].data = this.chartData.map((min, index) => {
        if (drinksBreakIndexes.has(index)) return '0.000';

        return Number(min.xT || 0).toFixed(3);
      });
      //Get home team goals
      this.xTChart.data.datasets[0].homeGoals = this.chartData.filter(min => min.homeGoalPlayerName);
      //Get home team missed penalties
      this.xTChart.data.datasets[0].homeMissedPenalties = this.chartData.filter(min => min.homeMissedPenaltyPlayerName);
      //Get home team red cards
      this.xTChart.data.datasets[0].homeRedCardsMinute = this.chartData.filter(min => min.homeRedCardPlayerName);
      //Get home team formation change
      this.xTChart.data.datasets[0].homeFormationChangeMinute = this.chartData.filter(min => min.homeNewFormation);
      //Get away team goals
      this.xTChart.data.datasets[0].awayGoals = this.chartData.filter(min => min.awayGoalPlayerName);
      //Get home team missed penalties
      this.xTChart.data.datasets[0].awayMissedPenalties = this.chartData.filter(min => min.awayMissedPenaltyPlayerName);
      //Get away team red cards
      this.xTChart.data.datasets[0].awayRedCardsMinute = this.chartData.filter(min => min.awayRedCardPlayerName);
      //Get away team formation change
      this.xTChart.data.datasets[0].awayFormationChangeMinute = this.chartData.filter(min => min.awayNewFormation);

      //Get away team formation change
      this.xTChart.data.datasets[0].startDrinksBreakMinute = this.chartData.filter(min => min.startDrinksBreak);

      //Get away team formation change
      this.xTChart.data.datasets[0].endDrinksBreakMinute = this.chartData.filter(min => min.endDrinksBreak);

      //Get max value away team (negative values)
      let maxValueAwayTeam = Math.min.apply(null, this.xTChart.data.datasets[0].data);
      //Get max value home team (positive values)
      let maxValueHomeTeam = Math.max.apply(null, this.xTChart.data.datasets[0].data);
      let yAxisRange = Math.max(Math.abs(maxValueAwayTeam), maxValueHomeTeam);
      if(yAxisRange >= 0.09){
        let checkEvenValue = round(yAxisRange * 100, 0);
        //Sum 0.03 for not even numbers
        let valueToSum = 0.03;
        if(checkEvenValue % 2 == 0){
          //Sum 0.02 for not even numbers
          valueToSum = 0.02;
        }
        yAxisRange = round(yAxisRange + valueToSum, 2);

        this.xTChart.options.scales.yAxes[0].ticks.min = -yAxisRange;
        this.xTChart.options.scales.yAxes[0].ticks.max = yAxisRange;
      }

      //Generate tooltips
      this.xTChart.data.datasets[0].tooltipItems = this.chartData.map(min => {
        let tooltipText = "";
        let gameResultText = "";
        let minuteText = min.minute > 45 && min.periodId === 1 ? `45+${min.minute - 45}' ` : min.minute + "' ";
        //First Goal Home Team
        if(min.homeGoalPlayerName){
          homeGoalsAccum++;
          tooltipText += minuteText + this.$t("game.gameFlow.goalOf") + min.homeGoalPlayerName + " (" + min.homeTeamAlias + ")" + "<br>";
        }
        //Second Goal Home Team (At the same minute as first one)
        if(min.homeSecondGoalPlayerName){
          homeGoalsAccum++;
          tooltipText += minuteText + this.$t("game.gameFlow.goalOf") + min.homeSecondGoalPlayerName + " (" + min.homeTeamAlias + ")" + "<br>";
        }
        //Missed Penalty
        if(min.homeMissedPenaltyPlayerName){
          tooltipText += minuteText + " " + this.$t("game.gameFlow.missedPenalty") + " " + this.$t("general.by").toLowerCase() +
          " " + min.homeMissedPenaltyPlayerName + " (" + min.homeTeamAlias + ")" + "<br>";
        }
        //First Red Card Home Team
        if(min.homeRedCardPlayerName){
          tooltipText += minuteText + this.$t("game.gameFlow.redCardTo") + min.homeRedCardPlayerName + " (" + min.homeTeamAlias + ")" + "<br>";
        }
        //Second Red Card Home Team (At the same minute as first one)
        if(min.homeSecondRedCardPlayerName){
          tooltipText += minuteText + this.$t("game.gameFlow.redCardTo") + min.homeSecondRedCardPlayerName + " (" + min.homeTeamAlias + ")" + "<br>";
        }
        //Formation Change Home Team
        if(min.homeNewFormation){
          tooltipText += minuteText + min.homeNewFormation + " (" + min.homeTeamAlias + ")" + "<br>";
        }
        //First Goal Away Team
        if(min.awayGoalPlayerName){
          awayGoalsAccum++;
          tooltipText += minuteText + this.$t("game.gameFlow.goalOf") + min.awayGoalPlayerName + " (" + min.awayTeamAlias + ")" + "<br>";
        }
        //Second Goal Away Team (At the same minute as first one)
        if(min.awaySecondGoalPlayerName){
          awayGoalsAccum++;
          tooltipText += minuteText + this.$t("game.gameFlow.goalOf") + min.awaySecondGoalPlayerName + " (" + min.awayTeamAlias + ")" + "<br>";
        }
        //First Red Card Away Team
        if(min.awayRedCardPlayerName){
          tooltipText += minuteText + this.$t("game.gameFlow.redCardTo") + min.awayRedCardPlayerName + " (" + min.awayTeamAlias + ")" + "<br>";
        }
        //Second Red Card Away Team (At the same minute as first one)
        if(min.awaySecondRedCardPlayerName){
          tooltipText += minuteText + this.$t("game.gameFlow.redCardTo") + min.awaySecondRedCardPlayerName + " (" + min.awayTeamAlias + ")" + "<br>";
        }
        //Formation Change Away Team
        if(min.awayNewFormation){
          tooltipText += minuteText + min.awayNewFormation + " (" + min.awayTeamAlias + ")" + "<br>";
        }

        //Start DrinksBreak 
        if(min.startDrinksBreak){
          tooltipText += minuteText + "Start Drinks Break" + "<br>";
        }

        //End DrinksBreak 
        if(min.endDrinksBreak){
          tooltipText += minuteText + "End Drinks Break" + "<br>";
        }

        gameResultText = min.homeTeamAlias + " " + homeGoalsAccum + " - " + awayGoalsAccum + " " + min.awayTeamAlias + `${(minuteText)}`;

        return {min: min.minute, tooltip: tooltipText, gameResult: gameResultText };
      });
      this.$forceUpdate();
      UserService.putLastSearchRendered({id:this.lastSearchId});
    },
    getAllGameMetricsPerPhases() {
      //Clear array
      this.gameFlowDataPerPhasesItems = [];
      this.gameFlowDataPerPhasesItems.length = 0;
      for(let i = 0; i < this.slicePeriod.length; i++){
        GameService.getGameFlowMetricsPerMins(this.gameId, this.slicePeriod[i], this.sliceMinFrom[i], this.sliceMinTo[i]).then(response => {
          if(this.gameFlowDataPerPhasesItems.length > 0){
            this.gameFlowDataPerPhasesItems = this.gameFlowDataPerPhasesItems.concat(response.data).sort((a, b) => {
              if (a.period !== b.period)
                return a.period - b.period;
              else if (a.minFrom !== b.minFrom)
                return a.minFrom - b.minFrom;
              else
                return a.teamId - b.teamId;
            });
          }else{
            this.gameFlowDataPerPhasesItems = response.data
          }
        });
      }//End for
    }
  }//End methods

};
</script>



// WEBPACK FOOTER //
// src/views/game/GameFlow.vue